import { ChangeEvent, FC } from 'react';
import PriceSlider from '../PriceSlider';
import { ModalHeader, ModalSection } from '../styles';
import { FieldType } from '../types';
import { useTranslations } from 'next-intl';

interface PriceSectionProps {
  minPrice?: number | null;
  maxPrice?: number | null;
  handleSliderChange: (event: Event, newValue: number | number[]) => void;
  maxAllowedPrice?: number;
  priceInterval?: number;
  handleTextFieldChange: (e: ChangeEvent<HTMLInputElement>, field: FieldType, min?: 'min') => void;
}

const sliderMaxRange = 10000000;
export const PriceSection: FC<PriceSectionProps> = ({
  minPrice,
  maxPrice,
  handleSliderChange,
  maxAllowedPrice,
  priceInterval,
  handleTextFieldChange,
}) => {
  const t = useTranslations();
  return (
    <ModalSection data-testid="price-section">
      <ModalHeader data-testid="price-header">{t('Price')}</ModalHeader>
      <PriceSlider
        minPrice={minPrice}
        maxPrice={maxPrice}
        handleSliderChange={handleSliderChange}
        maxAllowedPrice={maxAllowedPrice ? maxAllowedPrice : sliderMaxRange}
        priceInterval={priceInterval}
        handleTextFieldChange={handleTextFieldChange}
      />
    </ModalSection>
  );
};
